import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import Head from '../../components/Head';
import { NO_DIFF_TEXT, REQUIRED_TEXT_MESSAGE } from '../../utils/constants';
import { AsyncSelect, Input, InputFile } from '../../components/Form';
import {
  generateFormData,
  getDiffObjs,
  handleAPIErrors,
  minLenGenerator,
  permissionTypes,
  renameFileData,
} from '../../utils';
import {
  instructorDemandCreate,
  instructorDemandGet,
  instructorDemandUpdate,
  instructorGet,
  instructorUpdate,
  outgoingOrganizationConnectionDemandCreate,
} from '../store/action/instructor';
import Loader from '../../components/Loader';
import DarsupSweetAlert, { titleGenerator } from '../../components/SweetAlert';
import ImageFilePreview from '../../components/ImageFilePreview';
import Toast from '../../components/Toast';
import DarsupAlert from '../../components/Alert';
import { Link } from 'react-router-dom';
import { getFullPath } from '../../utils';
import { isUserInstructorInAnyOrg } from '../../utils/PermissionManager';

let InstructorForm = ({ history, match }) => {
  const [sweetShow, setSweetShow] = useState(undefined);
  let [updated, setUpdated] = useState(false); // used to redirect in update

  let detailOfInstructorDemand = useSelector(state => state.instructor.demand);
  let detailOfInstructor = useSelector(state => state.instructor.original);

  const dispatch = useDispatch();

  const { id } = match.params;
  let isDemand = !!new URLSearchParams(history.location.search).get('demand');
  let otherUser = !!new URLSearchParams(history.location.search).get('other_user');
  let isNewForm = history.location.pathname.includes('new');
  let isDemandAccepted = isDemand;

  const { permissions, selectedRole, selectedOrg } = useSelector(state => state.permission);

  //  react hook form
  const {
    handleSubmit,
    errors,
    control,
    formState: { dirtyFields },
    setError,
    clearError,
    setValue,
  } = useForm({ mode: 'onChange' });

  let filePreviewSrc;
  let isRenderedProfilePreview =
    id && (detailOfInstructorDemand.data || detailOfInstructor.data) && !dirtyFields.has('profile_image');
  if (isRenderedProfilePreview)
    filePreviewSrc = isDemand ? detailOfInstructorDemand.data?.profile_image : detailOfInstructor.data?.profile_image;

  let getErrMes = key => errors[key]?.message;

  function uploadFile(file, name) {
    let fileData = renameFileData(file, name);
    setValue(name, fileData);
  }

  let handleConfirm = () => setSweetShow(false);

  function onSubmit(data) {
    let tempData = { ...data };
    if (data.organizations_id)
      tempData = {
        ...tempData,
        organizations_id: data.organizations_id.map(item => item.value),
      };
    let formData;

    if (id) {
      // separate update demand with original
      let originalData;
      if (isDemand) originalData = { ...detailOfInstructorDemand.data, profile_image: undefined };
      else originalData = { ...detailOfInstructor.data, profile_image: undefined };

      let dirtyFields = getDiffObjs(originalData, tempData); // used to update
      if (!dirtyFields) {
        // show toastify to no dirty fields
        Toast(NO_DIFF_TEXT, 'warning');
        return;
      }

      formData = generateFormData(dirtyFields);
      // separate update demand with original
      if (isDemand) dispatch(instructorDemandUpdate(id, formData));
      else dispatch(instructorUpdate(formData));

      setUpdated(true);
    } else {
      // create demand(first time)
      formData = generateFormData(tempData);
      dispatch(instructorDemandCreate(formData));
    }
  }

  // useEffect(() => {
  //   if (selectedRole?.name !== permissionTypes.instructor) {
  //     history.push('/');
  //   }
  // }, [selectedRole]);

  useEffect(() => {
    if (id) {
      if (isDemand) dispatch(instructorDemandGet(id));
      else dispatch(instructorGet(id));
    }
  }, []);

  useEffect(() => {
    if (!id && detailOfInstructorDemand.data) setSweetShow(true);

    // to update organization
    let condition = id && detailOfInstructorDemand.data && !updated && isDemand;
    if (condition) {
      let { given_name, family_name, email, bio, organizations } = detailOfInstructorDemand.data;
      bio = bio.replace('<p>', '').replace('</p>', '');
      organizations = organizations.map(item => ({ label: item.name, value: item.id }));

      Object.entries({ given_name, family_name, email, bio, organizations_id: organizations }).forEach(
        ([key, value]) => {
          setValue(key, value);
        }
      );
    }

    if (id && detailOfInstructorDemand.data && updated) history.push('/');
  }, [detailOfInstructorDemand.data]);

  useEffect(() => {
    // to update organization
    let condition = id && detailOfInstructor.data && !updated && !isDemand;
    if (condition) {
      let { given_name, family_name, email, bio } = detailOfInstructor.data;
      bio = bio.replace('<p>', '').replace('</p>', '');
      Object.entries({ given_name, family_name, email, bio }).forEach(([key, value]) => {
        setValue(key, value);
      });
    }

    if (id && detailOfInstructor.data && updated) history.push('/me');
  }, [detailOfInstructor.data]);

  useEffect(() => {
    if (detailOfInstructorDemand.error) {
      handleAPIErrors(detailOfInstructorDemand.error, (name, message) => {
        setError(name, 'notMatch', message);
      });
    }
  }, [detailOfInstructorDemand.error]);

  useEffect(() => {
    if (!sweetShow && sweetShow !== undefined) history.push('/');
  }, [sweetShow]);

  return (
    <>
      <Head title={'استاد شوید'} />
      <div className="kt-portlet p-3 create-instructor">
        <div className="kt-portlet__body">
          <Container>
            {isDemandAccepted && !otherUser && (
              <DarsupAlert>
                <p className={'m-0'}>
                  <span className={'font-weight-bold'}>نکته:</span> درخواست شما برای استاد شدن، با موفقیت پذیرفته شده
                  است. برای نمایش و یا ویرایش اطلاعات به <Link to={'/me'}>صفحه من</Link> مراجعه کنید.
                </p>
              </DarsupAlert>
            )}
            <Row>
              <Col xl={{ span: 8, offset: 2 }}>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Row className={'mb-4'}>
                    <Col xs={12} lg={6} className={'mb-4'}>
                      <Input
                        type={'text'}
                        name={'given_name'}
                        control={control}
                        disabled={isDemand}
                        error={getErrMes('given_name')}
                        label={'نام استاد'}
                        rules={{ required: REQUIRED_TEXT_MESSAGE }}
                      />
                    </Col>
                    <Col xs={12} lg={6} className={'mb-4'}>
                      <Input
                        type={'text'}
                        name={'family_name'}
                        control={control}
                        disabled={isDemand}
                        error={getErrMes('family_name')}
                        label={'نام خانوادگی استاد'}
                        rules={{ required: REQUIRED_TEXT_MESSAGE }}
                      />
                    </Col>
                    {isNewForm && (
                      <Col xs={12} className={'mb-4'}>
                        <AsyncSelect
                          control={control}
                          name={'organizations_id'}
                          isMulti
                          optionPattern={{ label: 'name', value: 'id' }}
                          apiPath={'/manage/organizations/all/'}
                          queryParam={'search'}
                          label={'انتخاب سازمان'}
                        />
                      </Col>
                    )}
                    <Col xs={12} className={'mb-4'}>
                      <Input
                        type={'textarea'}
                        name={'bio'}
                        disabled={isDemand}
                        control={control}
                        error={getErrMes('bio')}
                        label={'معرفی استاد'}
                        placeholder={'متن معرفی استاد(حداقل ۳۰ حرف)'}
                        rows={'4'}
                        maxLength={'800'}
                        rules={{
                          required: REQUIRED_TEXT_MESSAGE,
                          minLength: { value: 30, message: minLenGenerator(30) },
                        }}
                      />
                    </Col>
                    <Col xs={12} className={'mb-4'}>
                      <Input
                        type={'text'}
                        name={'email'}
                        control={control}
                        error={getErrMes('email')}
                        label={'ایمیل'}
                        disabled={isDemand}
                        dir={'ltr'}
                        placeholder={'mail@example.com'}
                        rules={{ required: REQUIRED_TEXT_MESSAGE }}
                      />
                    </Col>
                    <Col xs={12} className={'mb-4'}>
                      {!isDemand ? (
                        <InputFile
                          name={'profile_image'}
                          control={control}
                          fileType={'image'}
                          limitSize={3}
                          label={'تصویر پروفایل'}
                          setError={setError}
                          clearError={clearError}
                          errors={errors}
                          error={getErrMes('profile_image')}
                          rules={{ required: !id ? REQUIRED_TEXT_MESSAGE : false }}
                          onUpload={uploadFile}
                        />
                      ) : (
                        <div />
                      )}
                      {isRenderedProfilePreview && (
                        <ImageFilePreview src={filePreviewSrc} caption={'تصویر آپلود شده'} />
                      )}
                    </Col>
                    <Col xs={12}>
                      {!isDemandAccepted && (
                        <Button type="submit" variant="primary" className="btn-block my-4 font-weight-bold">
                          {id ? 'ویرایش' : 'ثبت'}
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <Loader visible={detailOfInstructorDemand.isLoading || detailOfInstructor.isLoading} />
      <DarsupSweetAlert
        type={'success'}
        title={titleGenerator('instructor')}
        show={!!sweetShow}
        onConfirm={handleConfirm}
      >
        درخواست استاد شدن شما در سامانه درس آپ ثبت شد. نتیجه درخواست تا نهایتا دو ساعت برای شما ارسال خواهد شد.
      </DarsupSweetAlert>
    </>
  );
};

export default InstructorForm;
